module.exports = __webpack_public_path__ + "img/Oxygen.eda61d1a.png";